<div class="data-card">
  <div class="data-card__inner" [class.flip]="isRotatable">
    <div class="data-card__inner--front">
      <h3 [style.color]="cardTextColor"> {{mainTitle}} </h3>
      <h2 *ngIf="!isPercentage"> {{cumulativeData | number}} </h2>
      <p *ngIf="!isPercentage && todayCumulativeData">{{todayCumulativeData | number}}
        <span class="arrow" [style.color]="cardTextColor">&#8593;</span>
      </p>
      <h2 *ngIf="isPercentage"> {{cumulativeData | percent: "1.2"}} </h2>
      <mat-icon *ngIf="isRotatable">360</mat-icon>
    </div>
    <div class="data-card__inner--back">
      <h3 [style.color]="cardTextColor"> {{secondaryTitle}} </h3>
      <h2> {{perMillionCumulativeData | number}} </h2>
    </div>
  </div>
</div>
